/*jshint esversion: 6 */
"use strict";

function initI18n() {
    var i18nextInstance = i18next
        .use(i18nextBrowserLanguageDetector)
        .init({
            fallbackLng: 'en',
            debug: true,
            initImmediate: false,
            resources: {
                en: {
                    translation: {
                        home: {
                            title: {
                                "start": "We give you",
                                highPerformance: "high performance",
                                modernHardware: "modern hardware",
                                bestSupport: "best support",
                                ddosProtection: "DDoS protection",
                                lowPrices: "low prices",
                            },
                            subtitle: "We are a modern hosting provider with a top modern web interface and an app for Android and iOS for managing your servers from everywhere.",
                            getStartedButton: "Get started",
                            features: {
                                support: {
                                    title: "Excellent support",
                                    text: "Just contact us by mail, Discord or Skype, we will answer you as soon as possible."
                                },
                                webinterface: {
                                    title: "Self-developed Webinterface",
                                    text: "Manage all your services in our self-developed web interface."
                                },
                                prepaid: {
                                    title: "100% Prepaid",
                                    text: "All our services run on a prepaid basis and without contract periods. All without hidden fees."
                                },
                                hardware: {
                                    title: "High quality hardware",
                                    text: "Tube-Hosting exclusively uses hardware of renowned brand manufacturers (Intel, Supermicro, Cisco, ...)."
                                },
                                connectivity: {
                                    title: "Strong connectivity",
                                    text: "Tube-Hosting's network is internally redundant to 40 Gbit/s and offers sufficient resources for your projects."
                                },
                                ddos: {
                                    title: "DDoS Protection",
                                    text: "Combahton DDoS protection is included free of charge with each of our servers and can be managed in web interface and app."
                                },
                            },
                            webinterface: {
                                features: {
                                    serverManagement: {
                                        title: "Server Management",
                                        text: "Manage your servers by starting, stopping and reinstalling them."
                                    },
                                    payment: {
                                        title: "Several Payment Methods",
                                        text: "There are several payment methods available to top up your balance directly from the web interface and the app: Creditcard, Paypal, Sofort, Paysafecard"
                                    },
                                    statistics: {
                                        title: "Statistics",
                                        text: "View network, ram, cpu and storage statistics for all your vps."
                                    },
                                    ddos: {
                                        title: "DDoS Protection Management",
                                        text: "Manage DDoS protection of your IP addresses and view statistics on attacks received."
                                    }
                                },
                                moreAbout: "More about our Webinterface and App",
                                title: "Webinterface Features",
                                subtitle: "Discover a breathless experience in Server Management",
                            },
                            app: {
                                moreAbout: "More about our Webinterface and App",
                                availableFor1: "Our app is available for",
                                availableFor2: "your smartphone.",
                                subtitle: "All features of our Webinterface now in our official app.",
                                title: "Official App",
                                text: "Come to us and convince yourself of our high product quality and our numerous features.",
                            },
                            pricing: {
                                title: "Best Pricing",
                                subtitle: "You can start very cheap and get high performant servers.",
                                allPricesButton: "All prices"
                            }
                        },
                        datacenter: {
                            subtitle: "The backbone of our high-performance infrastructure",
                            text: "Tube-Hosting operates its infrastructure in the SkyLink data center in Eygelshoven, which was built according to Tier-3 standard. The data center is geographically located exactly between the two largest nodes worldwide (DE-CIX and AMS-IX). Our network benefits significantly from this location due to its proximity to the important nodes.",
                            features: {
                                routing: {
                                    title: "Optimal Routing",
                                    text: "Thanks to dark fiber connections to Frankfurt and Amsterdam and the connection to important carriers there, traffic can always take the shortest route, so that the latencies (ping times) are always low."
                                },
                                security: {
                                    title: "Security measures",
                                    text: "Access controls via keycard and video surveillance systems at relevant points ensure a high level of security by only allowing authorized persons access to the technical areas."
                                },
                                availability: {
                                    title: "High availability",
                                    text: "By using UPS systems, even in the unlikely event of a power failure, the continuous operation of the entire infrastructure can be guaranteed. You as a customer will not even notice this failure."
                                },
                                efficiency: {
                                    title: "Efficiency",
                                    text: "By using cold aisle containment, Tube-Hosting's infrastructure operates at peak efficiency."
                                },
                                scalability: {
                                    title: "Scalability",
                                    text: "Tube-Hosting has grown a lot within the last time. SkyLink data center is the perfect location for us because of many aspects, not less because of the great expansion possibilities we have at this location."
                                }
                            }
                        },
                        app: {
                            title: "Webinterface and App",
                            subtitle: "Everything at a glance, no matter where you are.",
                            getStartedButton: "Get Started",
                            nextFeatureButton: "Next Feature",
                            features: {
                                title: "What can our system?",
                                subtitle: "Here are some features listed.",
                                overview: {
                                    title: "Overview",
                                    text: "Have an overview of your servers and their performance from anywhere."
                                },
                                serverManagement: {
                                    title: "Server Management",
                                    text: "Get detailed insights into your individual servers, as well as the ability to install, reboot, shutdown and change your root password directly."
                                },
                                statistics: {
                                    title: "Server Statistics",
                                    text: "See the current load of your server, as well as statistics over selectable periods of up to one year. You can see the utilization of CPU, RAM, storage and network."
                                },
                                order: {
                                    title: "Quick and easy order",
                                    text: "Order one of our numerous servers in app and web interface and you will have access to product and invoice within moments."
                                }
                            }
                        },
                        pricing: {
                            monthly: "Monthly",
                            annualy: "Annualy",
                            features: {
                                unlimitedTraffic: "Unlimited Traffic",
                                link: "{{- size}} link",
                                ddosProtection: "DDoS Protection",
                                highPerformanceSSD: "High-Performance SSD Disks",
                                fastSupport: "Fast Support",
                                allFeatures: "All Features"
                            },
                            card: {
                                cpuCores: "{{count}} CPU cores",
                                coresAndClock: "{{cores}} cores, {{baseClock}} base clock, {{turboClock}} turbo clock",
                                diskSize: "{{size}} disk space",
                                perMonth: "/ month",
                                perYear: "/ year",
                            }
                        },
                        ddos: {
                            title: "DDoS Protection",
                            features: {
                                title: "Reasons for Tube Hosting DDoS Protection",
                                subtitle: "For its anti-DDoS solution, Tube-Hosting uses combahton's DDoS protection, which is specially optimized for game server applications. The DDoS protection is connected in front of our network via BGP session and is permanently active.",
                                bandwidth: {
                                    title: "High protection bandwidth",
                                    text: "Combahton's network has a remarkably high outer bandwidth and is thus capable of intercepting larger attacks."
                                },
                                gameServer: {
                                    title: "Optimized for gameserver",
                                    text: "Especially the protection of game server applications has become a special challenge, which we address with our protection solution."
                                },
                                inclusive: {
                                    title: "Free of charge included",
                                    text: "DDoS protection is included in all our products, regardless of whether they are dedicated servers or small vServers. We do not make any differences here."
                                },
                                intelligent: {
                                    title: "Intelligent DDoS protection",
                                    text: "DDoS protection is not only characterized by its bandwidth, but also by the \"intelligence\" of the applied filter mechanisms. Our DDoS protection is specially optimized for game server applications to guarantee the best protection here."
                                },
                                individual: {
                                    title: "Individual protection solutions",
                                    text: "Larger projects in particular are often the victims of more complex attacks. If this is the case, an individual protection solution can be developed together with support to meet the requirements of larger projects."
                                },
                                permanent: {
                                    title: "Permanent DDoS protection",
                                    text: "DDoS protection constantly monitors all network traffic and can apply adequate filtering mechanisms within a very short time in the event of an attack."
                                }
                            }
                        },
                        support:{
                            title: "Our support options",
                            subtitle: "At Tube-Hosting we attach great importance to the proximity to our customers, so that an optimal, invididual consultation as well as short response times can be made possible.",
                            options: {
                                discord: {
                                    title: "Discord",
                                    text: "You can contact us via Discord at any time. Our Discord tag is:",
                                    button: "Discord Server"
                                },
                                skype: {
                                    title: "Skype",
                                    text: "Contact us anytime via Skype at the following Skype name:",
                                    button: "Go to Skype"
                                },
                                email:{
                                    title: "Email",
                                    text: "You can reach us at any time at the following mail address:"
                                }
                            }
                        },
                        faq:{
                            title: "Frequently Asked Questions",
                            sections: {
                                general: {
                                    title: "General"
                                },
                                payment: {
                                    title: "Billing / Payment"
                                },
                                kvm: {
                                    title: "KVM-Rootserver"
                                },
                                lxc: {
                                    title: "vServer"
                                }
                            },
                            questions: {
                                serverLocation: {
                                    question: "Where is my server located?",
                                    answer: "All our servers are located in the SkyLink data centre in Eygelshoven. Find out more about our location here:"
                                },
                                webinterface: {
                                    question: "Welches Webinterface wird verwendet?",
                                    answer: "Bei Tube-Hosting erhalten Sie Zugang zu einem vollkommen eigens entwickelten Webinterface. Hier erhalten Sie weitere Infos über unser Webinterface."
                                },
                                ddosInclusive: {
                                    question: "Verfügt mein Server über einen DDoS-Schutz?",
                                    answer: "Ja, all unsere Server sind durch unseren DDoS-Schutz effektiv gegen sämtliche Arten von DDoS-Angriffen geschützt."
                                },
                                usedHardware: {
                                    question: "Welche Hardware wird bei Tube-Hosting genutzt?",
                                    answer: "Alle Infos zu unserer verwendet Hardware finden Sie hier:"
                                },
                                dockerServer: {
                                    question: "Ich möchte Docker auf meinem Server nutzen. Wird hier ein vServer oder ein KVM-Rootserver empfohlen?",
                                    answer: "Wenn auf einem Server Docker betrieben werden soll, empfehlen wir aufgrund der besseren Kompatibilität wegen des dedizierten Kernels unsere KVM-Rootserver."
                                },
                                supportInstallation: {
                                    question: "Könnt ihr mir Programme / Dienste auf meinem KVM-Rootserver installieren?",
                                    answer: {
                                        text: "Ja, all unsere Server sind durch unseren DDoS-Schutz effektiv gegen sämtliche Arten von DDoS-Angriffen geschützt.",
                                        programs: {
                                            minecraft: "Minecraft-Server (einzelne Server oder mehrere Server, die per Bungeecord verbunden sind)",
                                            teamspeak: "Teamspeak-Server",
                                            mysql: "MySQL-Datenbankserver",
                                            webserver: "Webserver (auf Wunsch auch mit Software wie Wordpress oder Nextcloud)"
                                        }
                                    }
                                },
                                backupInclusive: {
                                    question: "Werden Backups von meinem Server erstellt?",
                                    answer: "Zusätzlich zu unserem redundanten Speichersystem erstellen wir 1x täglich ein Backup von allen Servern. Diese Backups werden auf einem externen Speichersystem gelagert und für mindestens eine Woche aufbewahrt.\n" +
                                        "Eine Wiederherstellung über das Webinterface ist zum jetzigen Zeitpunkt noch nicht möglich, jedoch geplant. Falls Sie ein Backup benötigen, können Sie jederzeit den Support kontaktieren."
                                },
                                tubeHostingFoundation: {
                                    question: "Seit wann existiert Tube-Hosting?",
                                    answer: "Tube-Hosting wurde im März 2015 gegründet."
                                },
                                paymentMethods: {
                                    question: "Mit welchen Zahlungsmethoden kann bei Tube-Hosting gezahlt werden?",
                                    answer: "Unsere unterstützten Zahlungsmethoden finden Sie hier:"
                                },
                                contractPeriod: {
                                    question: "Bin ich bei Tube-Hosting an einen Vertrag bzw. an Vertragslaufzeiten gebunden?",
                                    answer: "Nein, all unsere Server laufen auf Prepaid-Basis. Sie zahlen nur für den Zeitraum, den Sie auswählen und gehen somit keinerlei Risiko ein.\n" +
                                        "Falls Sie Ihren Server nicht mehr verlängern möchten, müssen Sie rein gar nichts tun. Was genau passiert, wenn Ihr Server abgelaufen ist, entnehmen Sie aus der nächsten Frage."
                                },
                                stopExtendingService: {
                                    question: "Was passiert, wenn ich meinen Server nicht mehr verlängere?",
                                    answer: "Wenn Sie Ihren Server nicht verlängern, wird er zunächst deaktiviert und für 7 Tage gespeichert. Erst wenn nach diesen 7 Tagen keine Verlängerung Ihrerseits erfolgt, wird Ihr Server gelöscht. Dieser Löschvorgang ist endgültig und kann nicht rückgängig gemacht werden.\n" +
                                        "Vor der Deaktivierung und vor der Löschung erhalten Sie jeweils Benachrichtigungen von unserem System per E-Mail.\n" +
                                        "Hinweis: Sie können jedoch jederzeit den Tube-Hosting Support um einen zeitlichen Aufschub bitten (z.B. wegen Urlaub, Krankheit o. Ä.). Wir sind hier sehr kulant und können Ihren Server gerne für einen längeren Zeitraum offen halten bzw. gespeichert lassen. Falls sich Ihre Verlängerung beispielsweise nur um wenige Tage verzögert, kann der Server sogar ohne Deaktivierung online bleiben. Kontaktieren Sie uns einfach, falls Sie von diesem Service Gebrauch machen möchten."
                                },
                                kvmUpgrade:{
                                    question: "Kann später Leistung (RAM, Kerne, Festplatte) dazu gebucht und wieder gekündigt werden?",
                                    answer: "Ja, ein Upgrade oder Downgrade der Leistung (RAM, Kerne, Festplatte) ist jederzeit möglich. Hier kann entweder eine Laufzeitanpassung oder bei einem Upgrade für die Restlaufzeit des Servers eine Nachzahlung erfolgen."
                                },
                                kvmToLxcSwitch:{
                                    question: "Ist ein späterer Wechsel auf einen vServer möglich?",
                                    answer: "Die kurze Antwort auf diese Frage lautet: Ja, mit einigen Umständen.\n" +
                                        "Ein automatisierter Wechsel ist aufgrund der unterschiedlichen Virtualisierungstechnologien, die hier zum Einsatz kommen, nicht möglich. Es müsste ein vServer bestellt werden und anschließend die Daten des KVM-Rootservers auf den vServer übertragen werden. Danach können Sie den KVM-Rootserver einfach auslaufen lassen.\n" +
                                        "Gerne können Sie den Support kontaktieren, falls Sie Hilfe beim Umzug Ihrer Daten benötigen."
                                },
                                kvmLinkSpeed:{
                                    question: "Welche Anbindung besitzt mein KVM-Rootserver?",
                                    answer: "Unsere KVM-Rootserver besitzen eine 2 Gbit/s Anbindung an unser Netzwerk."
                                },
                                kvmVirtualizationTechnology:{
                                    question: "Welche Virtualisierungs-Technologie wird bei den KVM-Rootservern genutzt?",
                                    answer: "Bei unseren KVM-Rootservern kommt KVM als Virtualisierungstechnologie zum Einsatz. Hier profitieren Sie dank des dedizierten Kernels von besserer Leistung, größeren \"Freiheiten\" sowie von einer größeren Auswahl an Betriebssystemen (z.B. Windows)."
                                },
                                lxcUpgrade:{
                                    question: "Kann später Leistung (RAM, Kerne, Festplatte) dazu gebucht und wieder gekündigt werden?",
                                    answer: "Ja, ein Upgrade oder Downgrade der Leistung (RAM, Kerne, Festplatte) ist jederzeit möglich. Hier kann entweder eine Laufzeitanpassung oder bei einem Upgrade für die Restlaufzeit des Servers eine Nachzahlung erfolgen."
                                },
                                lxcToKvmSwitch:{
                                    question: "Ist ein späterer Wechsel auf einen KVM-Rootserver möglich?",
                                    answer: "Die kurze Antwort auf diese Frage lautet: Ja, mit einigen Umständen.\n" +
                                        "Ein automatisierter Wechsel ist aufgrund der unterschiedlichen Virtualisierungstechnologien, die hier zum Einsatz kommen, nicht möglich. Es müsste ein KVM-Rootserver bestellt werden und anschließend die Daten des vServers auf den KVM-Rootserver übertragen werden. Danach können Sie den vServer einfach auslaufen lassen.\n" +
                                        "Gerne können Sie den Support kontaktieren, falls Sie Hilfe beim Umzug Ihrer Daten benötigen."
                                },
                                lxcLinkSpeed:{
                                    question: "Welche Anbindung besitzt mein vServer?",
                                    answer: "Unsere vServer besitzen eine 1 Gbit/s Anbindung an unser Netzwerk."
                                },
                                lxcVirtualizationTechnology:{
                                    question: "Welche Virtualisierungs-Technologie wird bei den vServer genutzt?",
                                    answer: "Bei unseren vServern kommt LXC als Virtualisierungstechnologie zum Einsatz. Hier profitieren Sie von größter Flexibilität zu günstigen Preisen."
                                }
                            }
                        },
                        pageTitles: {
                            impressum: "Impressum",
                            privacyPolicy: "Privacy policy",
                            agb: "AGB",
                            status: "Status",
                            smokeping: "Smokeping",
                            support: "Support",
                            faq: "FAQ",
                            pricing: "Pricing",
                            ddos: "DDoS Protection",
                            datacenter: "Data center",
                            network: "Network",
                            hardware: "Hardware",
                            aboutUs: "About us"
                        },
                    }
                },
                de: {
                    translation: {
                        home: {
                            title: {
                                start: "Wir bieten",
                                highPerformance: "sehr gute Performance",
                                modernHardware: "moderne Hardware",
                                bestSupport: "herausragenden Support",
                                ddosProtection: "DDoS-Schutz",
                                lowPrices: "niedrige Preise",
                            },
                            subtitle: "Wir sind ein moderner Hosting-Anbieter mit einem top-modernen Webinterface und einer App für Android und iOS, sodass du deine Server von überall verwalten kannst.",
                            getStartedButton: "Jetzt loslegen",
                            features: {
                                support: {
                                    title: "Ausgezeichneter Support",
                                    text: "Kontaktieren Sie uns einfach per Mail, Discord oder Skype, wir werden Ihnen so schnell wie möglich antworten."
                                },
                                webinterface: {
                                    title: "Selbstentwickeltes Webinterface",
                                    text: "Verwalten Sie alle Ihre Dienste in unserer selbst entwickelten Webinterface."
                                },
                                prepaid: {
                                    title: "100% Prepaid",
                                    text: "Alle unsere Dienste laufen auf Prepaid-Basis und ohne Vertragslaufzeiten. Ganz ohne versteckte Gebühren."
                                },
                                hardware: {
                                    title: "Hochwertige Hardware",
                                    text: "Tube-Hosting verwendet ausschließlich Hardware von renommierten Markenherstellern (Intel, Supermicro, Cisco, ...)."
                                },
                                connectivity: {
                                    title: "Hohe Konnektivität",
                                    text: "Das Netzwerk von Tube-Hosting ist intern mit 40 Gbit/s redundant und bietet ausreichend Ressourcen für Ihre Projekte."
                                },
                                ddos: {
                                    title: "DDoS-Schutz",
                                    text: "Der DDoS-Schutz von Combahton ist kostenlos in jedem unserer Server enthalten und kann über ein Webinterface und eine App verwaltet werden."
                                },
                            },
                            webinterface: {
                                features: {
                                    serverManagement: {
                                        title: "Server-Management",
                                        text: "Verwalten Sie Ihre Server, indem Sie sie starten, stoppen und neu installieren."
                                    },
                                    payment: {
                                        title: "Verschiedene Zahlungsarten",
                                        text: "Es stehen mehrere Zahlungsmethoden zur Verfügung, um Ihr Guthaben direkt über das Webinterface und die App aufzuladen: Kreditkarte, Paypal, Sofort, Paysafecard"
                                    },
                                    statistics: {
                                        title: "Statistiken",
                                        text: "Betrachten Sie Netzwerk-, Ram-, CPU- und Speicherstatistiken für alle Ihre VPS."
                                    },
                                    ddos: {
                                        title: "DDoS-Schutz Verwaltung",
                                        text: "Verwalten Sie den DDoS-Schutz Ihrer IP-Adressen und sehen Sie sich die Statistiken über empfangene Angriffe an."
                                    }
                                },
                                moreAbout: "Mehr über unser Webinterface und unsere App",
                                title: "Webinterface Features",
                                subtitle: "Entdecken Sie eine außergewöhnliche Erfahrung im Server Management",
                            },
                            app: {
                                moreAbout: "Mehr über unser Webinterface and unsere App",
                                availableFor1: "Unsere App ist verfügbar für",
                                availableFor2: "dein Smartphone.",
                                subtitle: "Alle Features unseres Webinterfaces jetzt in unserer offiziellen App.",
                                title: "Offizielle App",
                                text: "Komme zu uns und überzeuge dich von unserer hohen Produktqualität und den zahlreichen Features.",
                            },
                            pricing: {
                                title: "Best Pricing",
                                subtitle: "Du kannst mit einem kleinen Budget starten und dann zu hochperformanten Server upgraden.",
                                allPricesButton: "Alle Preise"
                            }
                        },
                        datacenter: {
                            subtitle: "Das Rückgrat unserer High-Performance Infrastruktur",
                            text: "Tube-Hosting betreibt seine Infrastruktur im SkyLink-Rechenzentrum in Eygelshoven, welches nach Tier-3 Standard aufgebaut wurde. Das Rechenzentrum liegt geografisch genau zwischen den zwei größten Knotenpunkten weltweit (DE-CIX und AMS-IX). Unser Netzwerk profitiert aufgrund der Nähe zu den wichtigen Knotenpunkten maßgeblich von diesem Standort.",
                            features: {
                                routing: {
                                    title: "Optimales Routing",
                                    text: "Durch Darkfibre-Verbindungen nach Frankfurt und Amsterdam und den dortigen Anschluss an wichtige Carrier kann der Traffic immer den kürzesten Weg nehmen, sodass die Latenzen (Ping-Zeiten) stets gering sind."
                                },
                                security: {
                                    title: "Sicherheitsmaßnahmen",
                                    text: "Durch Zugangskontrollen per Keycard und Videoüberwachungssysteme an relevanten Stellen wird eine große Sicherheit gewährt, indem nur befugte Personen Zugriff auf die Technikflächen erhalten."
                                },
                                availability: {
                                    title: "Hohe Verfügbarkeit",
                                    text: "Durch den Einsatz von USV-Anlagen kann selbst im unwahrscheinlichen Falle eines Stromausfalls der fortlaufende Betrieb der gesamten Infrastruktur gewährt bleiben. Sie als Kunde bekommen von diesem Ausfall nicht ein Mal etwas mit."
                                },
                                efficiency: {
                                    title: "Effizienz",
                                    text: "Durch den Einsatz von Kaltgangeinhausung wird die Infrastruktur von Tube-Hosting mit höchster Effizienz betrieben."
                                },
                                scalability: {
                                    title: "Skalierbarkeit",
                                    text: "Tube-Hosting ist innerhalb der letzten Zeit stark gewachsen. Das SkyLink-Rechenzentrum ist aufgrund vieler Aspekte der perfekte Standort für uns, nicht weniger wegen der großen Erweiterungs-Möglichkeiten, die wir an diesem Standort haben."
                                }
                            }
                        },
                        app: {
                            title: "Webinterface und App",
                            subtitle: "Alles auf einen Blick, egal wo man ist.",
                            getStartedButton: "Jetzt loslegen",
                            nextFeatureButton: "Nächstes Feature",
                            features: {
                                title: "Was kann unser System?",
                                subtitle: "Hier sind einige Features aufgelistet.",
                                overview: {
                                    title: "Übersicht",
                                    text: "Habe von überall einen Überblick über deine Server und ihre Leistung."
                                },
                                serverManagement: {
                                    title: "Server Management",
                                    text: "Bekomme detaillierte Einsichten in deine einzelnen Server, sowie die Möglichkeit, diese direkt zu installieren, neu zu starten, herunterzufahren und dein Root-Passwort zu ändern."
                                },
                                statistics: {
                                    title: "Server Statistiken",
                                    text: "Siehe die aktuelle Auslastung deines Servers, sowie Statistiken über auswählbare Zeitspannen von bis zu einem Jahr. Einsehbar sind hierbei die Auslastungen von CPU, RAM, Speicher und Netzwerk."
                                },
                                order: {
                                    title: "Schnelle und einfache Bestellung",
                                    text: "Bestelle einen von unseren zahlreichen Server in App und Webinterface und du hast innerhalb weniger Augenblicke Zugriff auf Produkt und Rechnung."
                                }
                            }
                        },
                        pricing: {
                            monthly: "Monatlich",
                            annualy: "Jährlich",
                            features: {
                                unlimitedTraffic: "Unbegrenzter Traffic",
                                link: "{{- size}} link",
                                ddosProtection: "DDoS-Protection",
                                highPerformanceSSD: "Hochperformante SSD Disks",
                                fastSupport: "Schneller Support",
                                allFeatures: "Alle Features"
                            },
                            card: {
                                cpuCores: "{{count}} CPU-Kerne",
                                coresAndClock: "{{cores}} Kerne, {{baseClock}} Basistakt, {{turboClock}} Turbotakt",
                                diskSize: "{{size}} Disk-Space",
                                perMonth: "/ Monat",
                                perYear: "/ Jahr",
                            }
                        },
                        ddos: {
                            title: "DDoS-Schutz",
                            features: {
                                title: "Gründe für den Tube-Hosting DDoS-Schutz",
                                subtitle: "Tube-Hosting setzt bei seiner Anti-DDoS-Lösung auf die speziell für Gameserver-Anwendungen optimierte DDoS-Protection von combahton. Die DDoS-Protection ist mittels BGP-Session vor unser Netzwerk geschalten und dauerhaft aktiv.",
                                bandwidth: {
                                    title: "Hohe Schutz-Bandbreite",
                                    text: "Das Netzwerk von combahton verfügt über eine bemerkenswert hohe Außenbandbreite und ist somit in der Lage, größere Angriffe abzufangen."
                                },
                                gameServer: {
                                    title: "Optimiert für Gameserver",
                                    text: "Insbesondere der Schutz von Gameserver-Anwendungen ist zu einer besonderen Herausforderung herangewachsen, welchen wir mit unserer Schutzlösung adressieren."
                                },
                                inclusive: {
                                    title: "Kostenlos inklusive",
                                    text: "Die DDoS-Protection ist bei all unseren Produkten inklusive, egal ob dedizierter Server oder kleiner vServer. Hier machen wir keine Unterschiede."
                                },
                                intelligent: {
                                    title: "Intelligenter DDoS-Schutz",
                                    text: "Eine DDoS-Protection zeichnet sich bei weitem nicht nur durch ihre Außenbandbreite aus, sondern allem voran auch auch durch die \"Intelligenz\" der angewandten Filtermechanismen. Unser DDoS-Schutz ist speziell auf Gameserver-Anwendungen optimiert, um hier den besten Schutz zu garantieren."
                                },
                                individual: {
                                    title: "Individuelle Schutzlösungen",
                                    text: "Insbesondere größere Projekte sind oftmals Opfer komplexerer Attacken. Falls dies der Fall ist, kann gemeinsam mit dem Support eine individuelle Schutzlösung erarbeitet werden, um den Anforderungen größerer Projekte gerecht zu werden."
                                },
                                permanent: {
                                    title: "Permanenter DDoS-Schutz",
                                    text: "Die DDoS-Protection überwacht stetig den gesamten Netzwerkverkehr und kann im Angriffsfall binnen kürzester Zeit adäquate Filterungsmechanismen anwenden."
                                }
                            }
                        },
                        support:{
                            title: "Unsere Support Optionen",
                            subtitle: "Bei Tube-Hosting legen wir großen Wert auf die Nähe zu unseren Kunden, so dass eine optimale, individuelle Beratung sowie kurze Reaktionszeiten ermöglicht werden.",
                            options: {
                                discord: {
                                    title: "Discord",
                                    text: "Du kannst uns auf Discord jederzeit kontaktieren. Unser Discord-Tag ist:",
                                    button: "Discord Server"
                                },
                                skype: {
                                    title: "Skype",
                                    text: "Kontaktiere uns jederzeit auf Skype unter folgendem Skype-Namen:",
                                    button: "Auf zu Skype"
                                },
                                email:{
                                    title: "E-Mail",
                                    text: "Du kannst uns jederzeit unter folgender E-Mail-Adresse erreichen:"
                                }
                            }
                        },
                        faq:{
                            title: "Frequently Asked Questions",
                            sections: {
                                general: {
                                    title: "Allgemeines"
                                },
                                payment: {
                                    title: "Abrechnung / Zahlung"
                                },
                                kvm: {
                                    title: "KVM-Rootserver"
                                },
                                lxc: {
                                    title: "vServer"
                                }
                            },
                            questions: {
                                serverLocation: {
                                    question: "Wo steht mein Server?",
                                    answer: "All unsere Server stehen im SkyLink-Rechenzentrum in Eygelshoven. Hier erfahren Sie mehr über unseren Standort:"
                                },
                                webinterface: {
                                    question: "Welches Webinterface wird verwendet?",
                                    answer: "Bei Tube-Hosting erhalten Sie Zugang zu einem vollkommen eigens entwickelten Webinterface. Hier erhalten Sie weitere Infos über unser Webinterface."
                                },
                                ddosInclusive: {
                                    question: "Verfügt mein Server über einen DDoS-Schutz?",
                                    answer: "Ja, all unsere Server sind durch unseren DDoS-Schutz effektiv gegen sämtliche Arten von DDoS-Angriffen geschützt."
                                },
                                usedHardware: {
                                    question: "Welche Hardware wird bei Tube-Hosting genutzt?",
                                    answer: "Alle Infos zu unserer verwendet Hardware finden Sie hier:"
                                },
                                dockerServer: {
                                    question: "Ich möchte Docker auf meinem Server nutzen. Wird hier ein vServer oder ein KVM-Rootserver empfohlen?",
                                    answer: "Wenn auf einem Server Docker betrieben werden soll, empfehlen wir aufgrund der besseren Kompatibilität wegen des dedizierten Kernels unsere KVM-Rootserver."
                                },
                                supportInstallation: {
                                    question: "Könnt ihr mir Programme / Dienste auf meinem KVM-Rootserver installieren?",
                                    answer: {
                                        text: "Ja, all unsere Server sind durch unseren DDoS-Schutz effektiv gegen sämtliche Arten von DDoS-Angriffen geschützt.",
                                        programs: {
                                            minecraft: "Minecraft-Server (einzelne Server oder mehrere Server, die per Bungeecord verbunden sind)",
                                            teamspeak: "Teamspeak-Server",
                                            mysql: "MySQL-Datenbankserver",
                                            webserver: "Webserver (auf Wunsch auch mit Software wie Wordpress oder Nextcloud)"
                                        }
                                    }
                                },
                                backupInclusive: {
                                    question: "Werden Backups von meinem Server erstellt?",
                                    answer: "Zusätzlich zu unserem redundanten Speichersystem erstellen wir 1x täglich ein Backup von allen Servern. Diese Backups werden auf einem externen Speichersystem gelagert und für mindestens eine Woche aufbewahrt.\n" +
                                        "Eine Wiederherstellung über das Webinterface ist zum jetzigen Zeitpunkt noch nicht möglich, jedoch geplant. Falls Sie ein Backup benötigen, können Sie jederzeit den Support kontaktieren."
                                },
                                tubeHostingFoundation: {
                                    question: "Seit wann existiert Tube-Hosting?",
                                    answer: "Tube-Hosting wurde im März 2015 gegründet."
                                },
                                paymentMethods: {
                                    question: "Mit welchen Zahlungsmethoden kann bei Tube-Hosting gezahlt werden?",
                                    answer: "Unsere unterstützten Zahlungsmethoden finden Sie hier:"
                                },
                                contractPeriod: {
                                    question: "Bin ich bei Tube-Hosting an einen Vertrag bzw. an Vertragslaufzeiten gebunden?",
                                    answer: "Nein, all unsere Server laufen auf Prepaid-Basis. Sie zahlen nur für den Zeitraum, den Sie auswählen und gehen somit keinerlei Risiko ein.\n" +
                                        "Falls Sie Ihren Server nicht mehr verlängern möchten, müssen Sie rein gar nichts tun. Was genau passiert, wenn Ihr Server abgelaufen ist, entnehmen Sie aus der nächsten Frage."
                                },
                                stopExtendingService: {
                                    question: "Was passiert, wenn ich meinen Server nicht mehr verlängere?",
                                    answer: "Wenn Sie Ihren Server nicht verlängern, wird er zunächst deaktiviert und für 7 Tage gespeichert. Erst wenn nach diesen 7 Tagen keine Verlängerung Ihrerseits erfolgt, wird Ihr Server gelöscht. Dieser Löschvorgang ist endgültig und kann nicht rückgängig gemacht werden.\n" +
                                        "Vor der Deaktivierung und vor der Löschung erhalten Sie jeweils Benachrichtigungen von unserem System per E-Mail.\n" +
                                        "Hinweis: Sie können jedoch jederzeit den Tube-Hosting Support um einen zeitlichen Aufschub bitten (z.B. wegen Urlaub, Krankheit o. Ä.). Wir sind hier sehr kulant und können Ihren Server gerne für einen längeren Zeitraum offen halten bzw. gespeichert lassen. Falls sich Ihre Verlängerung beispielsweise nur um wenige Tage verzögert, kann der Server sogar ohne Deaktivierung online bleiben. Kontaktieren Sie uns einfach, falls Sie von diesem Service Gebrauch machen möchten."
                                },
                                kvmUpgrade:{
                                    question: "Kann später Leistung (RAM, Kerne, Festplatte) dazu gebucht und wieder gekündigt werden?",
                                    answer: "Ja, ein Upgrade oder Downgrade der Leistung (RAM, Kerne, Festplatte) ist jederzeit möglich. Hier kann entweder eine Laufzeitanpassung oder bei einem Upgrade für die Restlaufzeit des Servers eine Nachzahlung erfolgen."
                                },
                                kvmToLxcSwitch:{
                                    question: "Ist ein späterer Wechsel auf einen vServer möglich?",
                                    answer: "Die kurze Antwort auf diese Frage lautet: Ja, mit einigen Umständen.\n" +
                                        "Ein automatisierter Wechsel ist aufgrund der unterschiedlichen Virtualisierungstechnologien, die hier zum Einsatz kommen, nicht möglich. Es müsste ein vServer bestellt werden und anschließend die Daten des KVM-Rootservers auf den vServer übertragen werden. Danach können Sie den KVM-Rootserver einfach auslaufen lassen.\n" +
                                        "Gerne können Sie den Support kontaktieren, falls Sie Hilfe beim Umzug Ihrer Daten benötigen."
                                },
                                kvmLinkSpeed:{
                                    question: "Welche Anbindung besitzt mein KVM-Rootserver?",
                                    answer: "Unsere KVM-Rootserver besitzen eine 2 Gbit/s Anbindung an unser Netzwerk."
                                },
                                kvmVirtualizationTechnology:{
                                    question: "Welche Virtualisierungs-Technologie wird bei den KVM-Rootservern genutzt?",
                                    answer: "Bei unseren KVM-Rootservern kommt KVM als Virtualisierungstechnologie zum Einsatz. Hier profitieren Sie dank des dedizierten Kernels von besserer Leistung, größeren \"Freiheiten\" sowie von einer größeren Auswahl an Betriebssystemen (z.B. Windows)."
                                },
                                lxcUpgrade:{
                                    question: "Kann später Leistung (RAM, Kerne, Festplatte) dazu gebucht und wieder gekündigt werden?",
                                    answer: "Ja, ein Upgrade oder Downgrade der Leistung (RAM, Kerne, Festplatte) ist jederzeit möglich. Hier kann entweder eine Laufzeitanpassung oder bei einem Upgrade für die Restlaufzeit des Servers eine Nachzahlung erfolgen."
                                },
                                lxcToKvmSwitch:{
                                    question: "Ist ein späterer Wechsel auf einen KVM-Rootserver möglich?",
                                    answer: "Die kurze Antwort auf diese Frage lautet: Ja, mit einigen Umständen.\n" +
                                        "Ein automatisierter Wechsel ist aufgrund der unterschiedlichen Virtualisierungstechnologien, die hier zum Einsatz kommen, nicht möglich. Es müsste ein KVM-Rootserver bestellt werden und anschließend die Daten des vServers auf den KVM-Rootserver übertragen werden. Danach können Sie den vServer einfach auslaufen lassen.\n" +
                                        "Gerne können Sie den Support kontaktieren, falls Sie Hilfe beim Umzug Ihrer Daten benötigen."
                                },
                                lxcLinkSpeed:{
                                    question: "Welche Anbindung besitzt mein vServer?",
                                    answer: "Unsere vServer besitzen eine 1 Gbit/s Anbindung an unser Netzwerk."
                                },
                                lxcVirtualizationTechnology:{
                                    question: "Welche Virtualisierungs-Technologie wird bei den vServer genutzt?",
                                    answer: "Bei unseren vServern kommt LXC als Virtualisierungstechnologie zum Einsatz. Hier profitieren Sie von größter Flexibilität zu günstigen Preisen."
                                }
                            }
                        },
                        pageTitles: {
                            impressum: "Impressum",
                            privacyPolicy: "Datenschutzerklärung",
                            productInformation: "Products & Information",
                            agb: "AGB",
                            status: "Status",
                            smokeping: "Smokeping",
                            support: "Support",
                            faq: "FAQ",
                            pricing: "Preise",
                            ddos: "DDoS-Schutz",
                            datacenter: "Rechenzentrum",
                            network: "Netzwerk",
                            hardware: "Hardware",
                            aboutUs: "Über uns"
                        }
                    }
                }
            },
        }).then(function (i18nextInstance) {
            jqueryI18next.init(i18next, $, {
                tName: 't', // --> appends $.t = i18next.t
                i18nName: 'i18n', // --> appends $.i18n = i18next
                handleName: 'localize', // --> appends $(selector).localize(opts);
                selectorAttr: 'data-i18n', // selector for translating elements
                targetAttr: 'i18n-target', // data-() attribute to grab target element to translate (if different than itself)
                optionsAttr: 'i18n-options', // data-() attribute that contains options, will load/set if useOptionsAttr = true
                useOptionsAttr: true, // see optionsAttr
                parseDefaultValueFromContent: true // parses default values from content ele.val or ele.text
            });
            $(":root").localize();
        });
}